import OrderDetailsModalDialog from "./OrderDetailsModalDialog";

export default OrderDetailsModalDialog;
